import { observer } from 'mobx-react-lite';

import { IconMoreVertical } from '@components/icons/more-vertical';
import { Menu } from '@components/menu';

import { useApplicationOptions } from 'hooks/use-application-options';

export const ApplicationOptions = observer(({ data }) => {
  const actionsForApplication = useApplicationOptions();
  const actions = actionsForApplication(data);

  if (actions.length === 0) return null;

  return (
    <Menu
      buttonProps={{ iconLeft: <IconMoreVertical />, variant: 'secondary' }}
      label="Application options"
    >
      {actions.map((action, index) => {
        if (action === 'separator') return <Menu.Separator key={index} />;
        return (
          <Menu.Item
            key={action.label}
            icon={action.icon}
            onSelect={action.onSelect}
            label={action.label}
            variant={action.variant || 'base'}
            isDisabled={action.isDisabled?.(data)}
            tooltip={action.tooltip?.(data)}
          />
        );
      })}
    </Menu>
  );
});
